/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import wizardStyle from "../../wizardStyle";
import Grid from "@mui/material/Grid";
import { dateFieldDefault, requiredValidator } from "../../../../services/validationRules";
import ValidatorTextField from "../../../FormFields/ValidatorTextField";
import FormLegend from "../../Common/FormLegend/FormLegend";
import NumberFieldConfigured from "../../ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

type PropertyLoanProps = {
  path: string;
  index: number;
  product: AbstractCase;
};

export default function PropertyLoan({ path, index, product }: PropertyLoanProps) {
  return (
    <>
      <Grid sx={wizardStyle.gridTopSpaced} size={12}>
        <FormLegend>Machen Sie hier bitte nähere Angaben zum {index + 1}. Kredit.</FormLegend>
      </Grid>
      <Grid size={12}>
        <ValidatorTextField
          name={path + ".date"}
          label="Datum des Darlehensvertrages"
          validators={[requiredValidator("Bitte geben Sie das Datum an"), dateFieldDefault]}
        />
      </Grid>
      <Grid size={12}>
        <ValidatorTextField
          name={path + ".borrowers"}
          label="Darlehensnehmer"
          validators={[requiredValidator("Bitte geben Sie den oder die Darlehensnehmer an")]}
        />
      </Grid>
      <Grid size={12}>
        <ValidatorTextField name={path + ".bank"} label="Kreditinstitut" validators={[requiredValidator("Bitte geben Sie das Kreditinstitut an")]} />
      </Grid>
      <Grid size={12}>
        <ValidatorTextField
          name={path + ".remainingTerm"}
          label="Zahlungen laufen bis"
          validators={[requiredValidator("Bitte geben Sie an bis wann der Kredit läuft")]}
          helperText="Bis wann müssen Sie noch abbezahlen? Zum Beispiel: Mai 2022"
        />
      </Grid>
      <NumberFieldConfigured caseData={product} fieldPath={path + ".outstandingDebt"} fieldType={"money"} numberType={"float"} required />
      <NumberFieldConfigured caseData={product} fieldPath={path + ".repayment"} fieldType={"money"} numberType={"float"} required />
    </>
  );
}
